import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "8",
  height: "8"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M2.266 1.758v4.488c0 .34.379.547.668.363l3.523-2.242a.43.43 0 0 0 0-.73L2.934 1.39a.435.435 0 0 0-.668.367m0 0",
  style: {"stroke":"none","fill-rule":"nonzero","fill":"#fff","fill-opacity":"1"}
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }